import {
  getCartData,
  handleGWP,
  testCartMeetsCollectionPurchaseRequirement,
  testCartMeetsPriceThreshold,
  testCartMeetsProductPurchaseRequirement
} from "./chunk--chunk-FJ3DOTW4.vbt.js";
import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/components/GWP.js
var GWP = class {
  constructor(el, sel) {
    this.el = el;
    this.sel = sel;
    let props = el.getAttribute(sel);
    if (props) {
      props = JSON.parse(props);
    } else {
      throw new Error(
        "GWP component used, but its data attribute was not provided necessary props."
      );
    }
    const { graphql_storefront_access_token } = props;
    this.GRAPHQL_ENDPOINT = "/api/2024-07/graphql.json";
    this.STOREFRONT_ACCESS_TOKEN = graphql_storefront_access_token;
    this.localStorageKeys = {
      gwpThemeData: "muradGwpCodeThemeData",
      gwpUserInputCodes: "muradGwpUserInputCodes"
    };
    this.els = {
      wrapper: el.querySelector("#gwp-wrapper"),
      codeInput: el.querySelector("#input-gwp-coupon-code"),
      buttonSubmit: el.querySelector("#button-gwp-coupon-code"),
      divStatusMessage: el.querySelector("#status-gwp-coupon-code"),
      buttonRemoveSingleCode: el.querySelector("button#gwp-code-remove-single")
    };
    this.colors = {
      green: "var(--color-green-dark)",
      red: "var(--color-red)",
      grayDark: "var(--color-gray-dark)"
    };
    this.messages = {
      emptyCart: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Please add items to your cart to redeem coupon codes`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      addedNotValidated: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Applying ${codeValue}...`;
        wrapper.style.color = this.colors.green;
        return wrapper;
      },
      invalid: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Sorry, ${codeValue} is not valid`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      validMissingProducts: (codeValue, productsNeededToMeetRequirement, dollarsNeededToReachThresholdString, collectionsNeededToMeetRequirement, requiredPurchasesMustPurchaseAll) => {
        let wrapper = document.createElement("ul");
        wrapper.textContent = `For your free gift with ${codeValue.toUpperCase()}, add ${requiredPurchasesMustPurchaseAll ? "all" : "any"} to your cart: `;
        wrapper.style.color = this.colors.red;
        for (let product of productsNeededToMeetRequirement) {
          let anchorWrapper = document.createElement("li");
          let anchorLink = document.createElement("a");
          anchorLink.textContent = product.name;
          anchorLink.setAttribute("href", product.url);
          anchorLink.style.color = this.colors.grayDark;
          anchorLink.style.textDecoration = "underline";
          anchorWrapper.append(anchorLink);
          wrapper.append(anchorWrapper);
        }
        return wrapper;
      },
      validMissingCollectionProducts: (codeValue, productsNeededToMeetRequirement, dollarsNeededToReachThresholdString, collectionsNeededToMeetRequirement, requiredPurchasesMustPurchaseAll) => {
        let wrapper = document.createElement("ul");
        wrapper.textContent = `For your free gift with ${codeValue.toUpperCase()}, add to your cart an item from ${requiredPurchasesMustPurchaseAll ? "each" : "any"} of these collections: `;
        wrapper.style.color = this.colors.red;
        for (let collection of collectionsNeededToMeetRequirement) {
          let anchorWrapper = document.createElement("li");
          let anchorLink = document.createElement("a");
          anchorLink.textContent = collection.name;
          anchorLink.setAttribute("href", collection.url);
          anchorLink.style.color = this.colors.grayDark;
          anchorLink.style.textDecoration = "underline";
          anchorWrapper.append(anchorLink);
          wrapper.append(anchorWrapper);
        }
        return wrapper;
      },
      validBelowThreshold: (codeValue, productsNeededToMeetRequirement, dollarsNeededToReachThresholdString) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Add ${localStorage.getItem("muradGwpCodeCurrencySymbol") ?? "$"}${dollarsNeededToReachThresholdString} to your cart for your free gift with ${codeValue.toUpperCase()}`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      validApplied: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Free gift added for ${codeValue}`;
        wrapper.style.color = this.colors.green;
        return wrapper;
      },
      removed: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Removed ${codeValue}`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      removedEmptyCart: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `Removed ${codeValue}. Please add items to your cart to redeem coupon codes.`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      },
      // for Shopify Discounts only
      validAppliedShopifyDiscount: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `${codeValue} applied to cart`;
        wrapper.style.color = this.colors.green;
        return wrapper;
      },
      invalidShopifyDiscount: (codeValue) => {
        let wrapper = document.createElement("span");
        wrapper.textContent = `${codeValue} isn't valid for the items in your cart`;
        wrapper.style.color = this.colors.red;
        return wrapper;
      }
    };
    this.codeStatus = {
      addedNotValidated: "addedNotValidated",
      invalid: "invalid",
      validMissingProducts: "validMissingProducts",
      validMissingCollectionProducts: "validMissingCollectionProducts",
      validBelowThreshold: "validBelowThreshold",
      validApplied: "validApplied",
      removed: "removed",
      removedEmptyCart: "removedEmptyCart",
      // potential future status, if allow multiple codes;
      validReplaced: "validReplaced"
    };
    this.persistentStatuses = [
      this.codeStatus.validApplied,
      this.codeStatus.validMissingProducts,
      this.codeStatus.validMissingCollectionProducts,
      this.codeStatus.validBelowThreshold
    ];
    this.timeoutMessageReset = false;
    this.resetMessageAfterMs = 5e3;
    this.fakeHashForShopifyDiscountCodes = "SHOPIFY_DISCOUNT_CODE";
    this.activeShopifyDiscountCode = void 0;
    this.shopifyDiscountsRemoveCode = "MURAD_REMOVE_DISCOUNT_CODES";
    this.callbackTimeout = null;
    this.callbackTriggers = 0;
    this.handleRemoveCodeWithParams = null;
    this.SHOW_DEBUG_LOGS = false;
  }
  /**
   *
   * Generic helpers
   *
   */
  debug(...params) {
    if (!this.SHOW_DEBUG_LOGS) {
      return;
    }
    const LOG_STYLES_STRING = "color: #fff; font-size: 1.0rem; background-color: blue; padding: 4px";
    const LOG_STYLES_OBJECT = "color: #fff; font-size: 1.0rem; background-color: green; padding: 4px";
    if (typeof params[0] === "function") {
      console.log("%cfunction" + params[0], LOG_STYLES_STRING);
      this.testPerformance(...params);
    } else if (typeof params[0] === "string") {
      console.log("%c" + params[0], LOG_STYLES_STRING, ...params.slice(1));
    } else if (params.length === 1 && typeof params[0] === "object") {
      Object.keys(params[0]).forEach((key) => {
        console.log("%c" + key, LOG_STYLES_OBJECT, params[0][key]);
      });
    } else {
      for (let param of params) {
        if (typeof param === "string") {
          console.log("%c" + param, LOG_STYLES_STRING);
        } else {
          console.log("%c" + typeof param, LOG_STYLES_OBJECT, param);
        }
      }
    }
  }
  async sha256(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
    return hashHex;
  }
  async getCodeHash(codeValue) {
    return codeValue.trim() !== "" ? await this.sha256(codeValue.toUpperCase()) : "";
  }
  getLocal(key) {
    let stringVal = localStorage.getItem(key);
    if (!stringVal) {
      return void 0;
    }
    let parsedVal = JSON.parse(stringVal);
    return parsedVal;
  }
  setLocal(key, val) {
    var stringVal = JSON.stringify(val);
    localStorage.setItem(key, stringVal);
    return val;
  }
  /**
   *
   * Shopify Discounts helpers
   *
   */
  // apply Shopify Discount code to cart
  // https://community.shopify.com/c/technical-q-a/applying-discount-codes-in-the-cart-prior-to-checkout/m-p/800576
  async applyDiscountCode(code) {
    try {
      await fetch(`/discount/${code}`);
    } catch (err) {
      throw err;
    }
  }
  async removeDiscountCodes() {
    try {
      await this.applyDiscountCode(this.shopifyDiscountsRemoveCode);
    } catch (err) {
      throw err;
    }
  }
  // cart object: https://shopify.dev/docs/api/storefront/2024-07/objects/Cart
  // https://shopify.dev/docs/storefronts/headless/building-with-the-storefront-api/cart/manage
  async getCartDiscountCodes(cartId) {
    try {
      let res = await fetch(this.GRAPHQL_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({
          query: `query getCart($id: ID!) {
            cart(id: $id) {
              id
              createdAt
              updatedAt
              discountCodes {
                applicable
                code
              }
            }
          }`,
          variables: `{
            "id": "gid://shopify/Cart/${cartId}"
          }`
        })
      });
      let json = await res.json();
      let discountCodes = json?.data?.cart?.discountCodes;
      return discountCodes;
    } catch (err) {
      throw err;
    }
  }
  async getCartId() {
    try {
      let res = await fetch("/cart.js");
      let json = await res.json();
      return json?.token;
    } catch (err) {
      throw err;
    }
  }
  // get id of current cart, use it to retrieve discount codes applied to cart;
  async getCartIdAndDiscountCodes() {
    try {
      let cartId = await this.getCartId();
      if (cartId) {
        let discountCodes = await this.getCartDiscountCodes(cartId);
        return discountCodes;
      } else {
        return [];
      }
    } catch (err) {
      console.error(err);
    }
  }
  async applyTestShopifyDiscount(gwpInputVal) {
    try {
      await this.applyDiscountCode(gwpInputVal);
      let isApplicableDiscountCode = await this.checkDiscountCodes();
      return isApplicableDiscountCode;
    } catch (err) {
      throw err;
    }
  }
  /**
   *
   * Component-specific helpers
   *
   */
  getThemeGwpData() {
    return this.getLocal(this.localStorageKeys.gwpThemeData) ?? [];
  }
  getUserInputCodes() {
    return this.getLocal(this.localStorageKeys.gwpUserInputCodes) ?? [];
  }
  setUserInputCodes(val) {
    return this.setLocal(this.localStorageKeys.gwpUserInputCodes, val) ?? [];
  }
  updateStatusMessage(el, resetMessage) {
    clearTimeout(this.timeoutMessageReset);
    this.els.divStatusMessage.replaceChildren(el);
    if (resetMessage) {
      this.timeoutMessageReset = setTimeout(() => {
        this.updateStatusMessage(resetMessage);
      }, this.resetMessageAfterMs);
    }
  }
  async handleRemoveDiscountCode(codeValue, messageType = "removed") {
    this.debug("handleRemoveDiscountCode");
    try {
      await this.removeDiscountCodes();
      this.updateStatusMessage(
        this.messages[messageType](codeValue, void 0, void 0)
      );
      this.activeShopifyDiscountCode = void 0;
      this.updateCartVarfaj();
    } catch (err) {
      throw err;
    }
  }
  async handleRemoveGwpCode(codeObj) {
    try {
      await this.removeCode(codeObj.codeValue, codeObj.codeHash);
      this.updateUIAppliedCodes();
    } catch (err) {
      throw err;
    }
  }
  updateInput(codeToShowInInput) {
    let gwpInput = this.el.querySelector("#input-gwp-coupon-code");
    const resetInput = () => {
      gwpInput.disabled = false;
      gwpInput.value = "";
      this.disableSubmitButton();
      this.els.buttonRemoveSingleCode.classList.add("hidden");
      this.els.buttonRemoveSingleCode.removeEventListener(
        "click",
        // testPerfHandleRemoveCode,
        // handleRemoveCode,
        this.handleRemoveCodeWithParams
      );
    };
    const handleRemoveCode = async (codeToShowInInput2) => {
      try {
        if (codeToShowInInput2.codeHash === this.fakeHashForShopifyDiscountCodes) {
          await this.handleRemoveDiscountCode(
            codeToShowInInput2.codeValue,
            "removed"
          );
        } else {
          await this.handleRemoveGwpCode(codeToShowInInput2);
        }
        resetInput();
      } catch (err) {
        console.error(err);
      }
    };
    if (codeToShowInInput) {
      this.els.buttonRemoveSingleCode.removeEventListener(
        "click",
        // testPerfHandleRemoveCode,
        // () => this.handleRemoveCode(codeToShowInInput),
        this.handleRemoveCodeWithParams
      );
      this.handleRemoveCodeWithParams = () => handleRemoveCode(codeToShowInInput);
      this.disableSubmitButton();
      gwpInput.disabled = true;
      gwpInput.value = codeToShowInInput.codeValue;
      this.els.buttonRemoveSingleCode.classList.remove("hidden");
      this.els.buttonRemoveSingleCode.addEventListener(
        "click",
        // testPerfHandleRemoveCode,
        // () => this.handleRemoveCode(codeToShowInInput),
        this.handleRemoveCodeWithParams
      );
    } else {
      resetInput();
    }
  }
  /**
   *
   * Core methods
   *
   */
  async removeItemArrayFromCart(variantIdArray) {
    try {
      let updates = variantIdArray.reduce((prev, curr) => {
        return {
          ...prev,
          [curr]: 0
        };
      }, {});
      try {
        await fetch(`/cart/update.js`, {
          headers: {
            "Content-Type": "application/json"
          },
          method: "POST",
          body: JSON.stringify({ updates })
        });
        this.updateCartVarfaj();
      } catch (err) {
        console.error(err);
      }
    } catch (err) {
      throw err;
    }
  }
  async removeGiftCodeItem(hash) {
    try {
      let gwpThemeData = this.getThemeGwpData();
      if (gwpThemeData && Array.isArray(gwpThemeData)) {
        let productToRemove = gwpThemeData.find((val) => val.codeHash === hash);
        if (productToRemove) {
          this.removeItemArrayFromCart([productToRemove.variantId]);
        }
      }
    } catch (err) {
      throw err;
    }
  }
  // marks code as "removed" and updates UI and cart accordingly; does not remove from localStorage, which allows persistence of status message after page reload, and may offer benefits to future features;
  async removeCode(codeValue, codeHash) {
    let userInputCodes = this.getUserInputCodes();
    let codeToBeRemoved = userInputCodes.find(
      (val) => val.codeHash === codeHash
    );
    let codeStatusBeforeRemoval = codeToBeRemoved?.status;
    this.addUpdateUserCode({
      codeValue,
      codeHash,
      status: this.codeStatus.removed
    });
    if (codeStatusBeforeRemoval === this.codeStatus.validApplied) {
      await this.removeGiftCodeItem(codeHash);
    }
  }
  updateUIAppliedCodes(allowMultipleCodes = false) {
    let userInputCodes = this.getUserInputCodes();
    if (allowMultipleCodes) {
    } else {
      let lastUpdatedCode = userInputCodes[0];
      if (lastUpdatedCode) {
        let {
          codeValue,
          codeHash,
          status,
          productsNeededToMeetRequirement,
          dollarsNeededToReachThresholdString,
          collectionsNeededToMeetRequirement,
          requiredPurchasesMustPurchaseAll
        } = lastUpdatedCode;
        if (this.persistentStatuses.includes(status)) {
          this.updateStatusMessage(
            this.messages[status](
              codeValue,
              productsNeededToMeetRequirement,
              dollarsNeededToReachThresholdString,
              collectionsNeededToMeetRequirement,
              requiredPurchasesMustPurchaseAll
            )
          );
        } else if (Date.now() - lastUpdatedCode.timeUpdated < this.resetMessageAfterMs) {
          this.updateStatusMessage(
            this.messages[status](
              codeValue,
              productsNeededToMeetRequirement,
              dollarsNeededToReachThresholdString,
              collectionsNeededToMeetRequirement,
              requiredPurchasesMustPurchaseAll
            )
          );
        }
      }
      let codeToShowInInput = userInputCodes.find(
        (codeObj) => this.persistentStatuses.includes(codeObj.status)
      );
      this.updateInput(codeToShowInInput);
    }
  }
  addUpdateUserCode(codeObj) {
    const { codeValue, codeHash, status } = codeObj;
    codeObj.timeUpdated = Date.now();
    let userInputCodes = this.getUserInputCodes();
    let updatedUserInputCodes = [...userInputCodes];
    if (status === this.codeStatus.validApplied) {
      for (let thisCodeObj of updatedUserInputCodes) {
        if (thisCodeObj.codeStatus === this.codeStatus.validApplied) {
          thisCodeObj.codeStatus = this.codeStatus.validReplaced;
        }
      }
    }
    let codeToUpdateIndex = updatedUserInputCodes.findIndex(
      (val) => val.codeValue === codeValue && val.codeHash === codeHash
    );
    if (codeToUpdateIndex > -1) {
      let codeToUpdate = updatedUserInputCodes.splice(codeToUpdateIndex, 1)[0];
      updatedUserInputCodes = [
        { ...codeToUpdate, ...codeObj },
        ...updatedUserInputCodes
      ];
    } else {
      codeObj.timeAdded = Date.now();
      updatedUserInputCodes = [codeObj, ...updatedUserInputCodes];
    }
    this.setUserInputCodes(updatedUserInputCodes);
    return codeObj;
  }
  getThemeDataForCode(codeValue, codeHash) {
    let activeGwpCodeData = this.getThemeGwpData();
    var gwpInputValHashMatch = activeGwpCodeData.find(
      (val) => val.codeHash === codeHash
    );
    return gwpInputValHashMatch;
  }
  async getCodeStatus(codeObj, cartData) {
    try {
      const { codeValue, codeHash, status } = codeObj;
      const { cartRaw, cartItemVariantIds, cartTotalPrice } = cartData;
      if (status === this.codeStatus.removed || status === this.codeStatus.removedEmptyCart || status === this.codeStatus.invalid) {
        return codeObj;
      }
      let gwpInputValHashMatch = this.getThemeDataForCode(codeValue, codeHash);
      if (!gwpInputValHashMatch) {
        return {
          status: this.codeStatus.invalid,
          productsNeededToMeetRequirement: void 0,
          dollarsNeededToReachThresholdString: void 0,
          collectionsNeededToMeetRequirement: void 0,
          requiredPurchasesMustPurchaseAll: void 0
        };
      }
      if (cartTotalPrice === 0) {
        return {
          status: this.codeStatus.removedEmptyCart,
          productsNeededToMeetRequirement: void 0,
          dollarsNeededToReachThresholdString: void 0,
          collectionsNeededToMeetRequirement: void 0,
          requiredPurchasesMustPurchaseAll: void 0
        };
      }
      const {
        requiredProductPurchases,
        requiredCollectionPurchases,
        requiredPurchasesMustPurchaseAll,
        threshold
      } = gwpInputValHashMatch;
      if (requiredProductPurchases.length > 0) {
        let {
          doesMeetProductPurchaseRequirement,
          productsNeededToMeetRequirement
        } = testCartMeetsProductPurchaseRequirement(
          requiredProductPurchases,
          cartItemVariantIds,
          requiredPurchasesMustPurchaseAll
        );
        if (!doesMeetProductPurchaseRequirement) {
          return {
            status: this.codeStatus.validMissingProducts,
            productsNeededToMeetRequirement,
            dollarsNeededToReachThresholdString: void 0,
            collectionsNeededToMeetRequirement: void 0,
            requiredPurchasesMustPurchaseAll
          };
        }
      }
      if (requiredCollectionPurchases.length > 0) {
        let {
          doesMeetCollectionPurchaseRequirement,
          collectionsNeededToMeetRequirement
        } = testCartMeetsCollectionPurchaseRequirement(
          requiredCollectionPurchases,
          cartItemVariantIds,
          requiredPurchasesMustPurchaseAll
        );
        console.log({
          doesMeetCollectionPurchaseRequirement,
          collectionsNeededToMeetRequirement
        });
        if (!doesMeetCollectionPurchaseRequirement) {
          return {
            status: this.codeStatus.validMissingCollectionProducts,
            productsNeededToMeetRequirement: void 0,
            dollarsNeededToReachThresholdString: void 0,
            collectionsNeededToMeetRequirement,
            requiredPurchasesMustPurchaseAll
          };
        }
      }
      let { doesMeetThreshold, dollarsNeededToReachThresholdString } = testCartMeetsPriceThreshold(threshold, cartTotalPrice);
      if (!doesMeetThreshold) {
        return {
          status: this.codeStatus.validBelowThreshold,
          productsNeededToMeetRequirement: void 0,
          dollarsNeededToReachThresholdString,
          collectionsNeededToMeetRequirement: void 0,
          requiredPurchasesMustPurchaseAll
        };
      }
      return {
        status: this.codeStatus.validApplied,
        productsNeededToMeetRequirement: void 0,
        dollarsNeededToReachThresholdString: void 0,
        collectionsNeededToMeetRequirement: void 0,
        requiredPurchasesMustPurchaseAll
      };
    } catch (err) {
      throw err;
    }
  }
  async testCodeValidity(codeObj, cartData) {
    try {
      const {
        codeValue,
        codeHash,
        status,
        productsNeededToMeetRequirement,
        dollarsNeededToReachThresholdString,
        collectionsNeededToMeetRequirement,
        requiredPurchasesMustPurchaseAll
      } = codeObj;
      const updatedStatus = await this.getCodeStatus(codeObj, cartData);
      if (updatedStatus.status !== status || updatedStatus.productsNeededToMeetRequirement !== productsNeededToMeetRequirement || updatedStatus.collectionsNeededToMeetRequirement !== collectionsNeededToMeetRequirement || updatedStatus.dollarsNeededToReachThresholdString !== dollarsNeededToReachThresholdString) {
        return this.addUpdateUserCode({
          codeValue,
          codeHash,
          ...updatedStatus
        });
      } else {
        return codeObj;
      }
    } catch (err) {
      throw err;
    }
  }
  async removeStaleGifts(cartItemsWithGwpProps) {
    let productsToRemove = [];
    for (let cartItem of cartItemsWithGwpProps) {
      const { _gwp_code_hash, _gwp_code_value } = cartItem.properties;
      if (_gwp_code_hash && _gwp_code_hash !== this.fakeHashForShopifyDiscountCodes) {
        let gwpThemeData = this.getThemeGwpData();
        let gwpCodeIsInTheme = gwpThemeData.find(
          (codeVal) => codeVal.codeHash === _gwp_code_hash
        );
        if (!gwpCodeIsInTheme) {
          this.debug(
            `Gift assoc. with ${_gwp_code_value} in cart, but code no longer in GWP settings; removing gift;`
          );
          productsToRemove.push(cartItem.variant_id);
        }
      }
    }
    if (productsToRemove.length > 0) {
      await this.removeItemArrayFromCart(productsToRemove);
    }
  }
  async testAllAddedCodes(userInputCodes) {
    try {
      let cartData = await getCartData();
      for (let codeObj of userInputCodes) {
        let testedCodeObj = await this.testCodeValidity(codeObj, cartData);
      }
      this.removeStaleGifts(cartData.cartItemsWithGwpProps);
    } catch (err) {
      throw err;
    }
  }
  updateCartVarfaj() {
    this.debug("updateCartVarfaj");
    const cartType = window.location.href.includes("/cart") ? "cart-page" : "ajaxcart";
    handleGWP(cartType);
  }
  async applyTestGwpCode(codeValue, cartData) {
    try {
      var codeHash = await this.getCodeHash(codeValue);
      let savedCodeObj = this.addUpdateUserCode({
        codeValue,
        codeHash,
        status: this.codeStatus.addedNotValidated
      });
      let testedCodeObj = await this.testCodeValidity(savedCodeObj, cartData);
      if (testedCodeObj.status === this.codeStatus.validApplied) {
        return true;
      }
      return false;
    } catch (err) {
      throw err;
    }
  }
  async handleSubmitCode() {
    try {
      this.disableSubmitButton();
      let inputCode = this.els.codeInput;
      let codeValue = inputCode.value.toUpperCase();
      let cartData = await getCartData();
      if (cartData.cartTotalPrice === 0) {
        this.updateStatusMessage(this.messages.emptyCart());
        inputCode.value = "";
        return;
      }
      let isApplicableGwpCode = await this.applyTestGwpCode(
        codeValue,
        cartData
      );
      if (isApplicableGwpCode) {
        this.updateUIAppliedCodes();
        this.updateCartVarfaj();
        return;
      }
      let isApplicableDiscountCode = await this.applyTestShopifyDiscount(codeValue);
      if (isApplicableDiscountCode) {
        this.updateCartVarfaj();
        return;
      }
      this.updateUIAppliedCodes();
    } catch (err) {
      console.error(err);
      this.enableSubmitButton();
      throw err;
    }
  }
  disableSubmitButton() {
    let gwpSubmitBtn = this.els.buttonSubmit;
    gwpSubmitBtn.classList.add("opacity-50");
    gwpSubmitBtn.disabled = true;
  }
  enableSubmitButton() {
    let gwpSubmitBtn = this.els.buttonSubmit;
    gwpSubmitBtn.classList.remove("opacity-50");
    gwpSubmitBtn.disabled = false;
  }
  async testPerformance(testFunc, funcName, iterations = 1) {
    console.time(funcName);
    for (var i = 0; i < iterations; i++) {
      await testFunc();
    }
    const LOG_STYLES_PERF = "color: #fff; font-size: 1.0rem; background-color: red; padding: 4px";
    console.log(`%cPerformance ${funcName}`, LOG_STYLES_PERF);
    console.timeEnd(funcName);
  }
  addEventListeners(el) {
    let gwpSubmitBtn = this.els.buttonSubmit;
    gwpSubmitBtn.addEventListener("click", () => {
      try {
        this.handleSubmitCode();
      } catch (err) {
        console.error(err);
      }
    });
    let gwpInput = this.els.codeInput;
    ["input", "change", "keypress"].forEach((eventType) => {
      gwpInput?.addEventListener(eventType, (e) => {
        const inputVal = e.currentTarget.value;
        if (eventType === "keypress") {
          if (e.code === "Enter") {
            e.preventDefault();
            try {
              if (inputVal.trim() !== "") {
                this.handleSubmitCode();
              }
            } catch (err) {
              console.error(err);
            }
            return;
          }
        }
        if (inputVal.trim() !== "") {
          this.enableSubmitButton();
        } else {
          this.disableSubmitButton();
        }
      });
    });
  }
  async testCodesUpdateUI() {
    try {
      let isApplicableDiscountCode = await this.checkDiscountCodes();
      if (isApplicableDiscountCode) {
        return;
      }
      await this.testAllAddedCodes(this.getUserInputCodes());
      this.updateUIAppliedCodes();
    } catch (err) {
      console.error(err);
    }
  }
  isValidCodePresent() {
    if (this.activeShopifyDiscountCode) {
      return true;
    }
    let userInputCodes = this.getUserInputCodes();
    let validCode = userInputCodes.find(
      (codeObj) => this.persistentStatuses.includes(codeObj.status)
    );
    if (validCode) {
      return true;
    }
    return false;
  }
  async checkDiscountCodes() {
    try {
      let cartDiscountCodes = await this.getCartIdAndDiscountCodes();
      this.debug({ cartDiscountCodes });
      if (cartDiscountCodes && cartDiscountCodes.length > 0) {
        let firstApplicableCode = cartDiscountCodes.find(
          (val) => val.applicable
        );
        if (firstApplicableCode) {
          let userInputCodes = this.getUserInputCodes();
          for (let eachCode of userInputCodes) {
            if (eachCode.status === this.codeStatus.validApplied || eachCode.status === this.codeStatus.validMissingProducts || eachCode.status === this.codeStatus.validBelowThreshold) {
              this.removeCode(eachCode.codeValue, eachCode.codeHash);
            }
          }
          this.updateInput({
            codeValue: firstApplicableCode.code,
            codeHash: this.fakeHashForShopifyDiscountCodes
          });
          this.updateStatusMessage(
            this.messages.validAppliedShopifyDiscount(
              firstApplicableCode.code,
              void 0,
              void 0
            )
          );
          this.activeShopifyDiscountCode = firstApplicableCode.code;
          return true;
        } else {
        }
      }
      if (this.activeShopifyDiscountCode) {
        this.handleRemoveDiscountCode(
          this.activeShopifyDiscountCode,
          "invalidShopifyDiscount"
        );
      } else if (cartDiscountCodes?.[0] && cartDiscountCodes !== this.shopifyDiscountsRemoveCode) {
        this.removeDiscountCodes();
      }
      return false;
    } catch (err) {
      throw err;
    }
  }
  unhide() {
    let themeData = this.getThemeGwpData();
    if (themeData.length > 0) {
      this.els.wrapper.style.display = "block";
    }
  }
  observeSlideOutCartChanges() {
    const observerTargetNode = document.querySelector(
      "div[data-ajax-cart-section]"
    );
    const observerOptions = {
      subtree: true,
      childList: true,
      attributes: false
    };
    const setCallbackTimeout = (observer2, callback, timeoutMs = 200, maxCallbackTriggers = 999999999) => {
      clearTimeout(this.callbackTimeout);
      this.callbackTimeout = setTimeout(() => {
        if (this.callbackTriggers < maxCallbackTriggers) {
          this.debug("Timeout expired; triggering callback;");
          this.callbackTriggers++;
          callback();
          if (this.callbackTriggers >= maxCallbackTriggers) {
            observer2.disconnect();
          }
        } else {
        }
      }, timeoutMs);
    };
    const mutationCallback = async (mutationRecordArray, observer2) => {
      if (this.isValidCodePresent()) {
        try {
          setCallbackTimeout(observer2, async () => {
            await this.testCodesUpdateUI();
          });
        } catch (err) {
          console.error(err);
        }
      }
    };
    const observer = new MutationObserver(mutationCallback);
    observer.observe(observerTargetNode, observerOptions);
  }
  async init() {
    try {
      handleGWP("ajaxcart");
      await this.testCodesUpdateUI();
      this.addEventListeners(this.el);
      this.observeSlideOutCartChanges();
    } catch (err) {
      console.error(err);
    }
  }
  /**
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   * UNUSED Methods; created when testing alternative methods of implementing "gifts with purchase with code"; namely purely custom (via theme data and front-end handling); native Shopify Discounts with additional work to automatically add the target free item; and hybrid approaches
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   */
  // if adding to cart directly instead of handing off to handleGWP()
  // await this.handleAddToCartBatch([gwpInputValHashDoesMatch.variantId]);
  // if (window.location.pathname === "/cart") {
  //   window.scrollTo(0, 0);
  //   window.location.reload();
  // }
  // from skin quiz implementation; can be deleted;
  updateCart(sectionsJson) {
    try {
      const div = document.createElement("div");
      div.innerHTML = sectionsJson.ajaxcart;
      const cartContent = div.querySelector("[data-ajax-cart-content]");
      const cartEl = document.querySelector(
        "[data-ajax-cart] [data-ajax-cart-content]"
      ).parentNode;
      cartEl.innerHTML = "";
      cartEl.appendChild(cartContent);
      const subtotal = div.querySelector("#subtotal").value;
      const itemCount = div.querySelector("#item_count").value;
      const hasMin = div.querySelector("#has_min").value;
      const productHandles = div.querySelector("#product_handles").value;
      document.dispatchEvent(
        new CustomEvent("ajaxcart refresh", {
          detail: {
            subtotal,
            itemCount,
            hasMin,
            productHandles
          }
        })
      );
    } catch (err) {
      console.error(err);
    }
  }
  // from skin quiz implementation; can be deleted;
  async addToCartShopify(variantIdArray = [0]) {
    console.log({ variantIdArray });
    try {
      let formData = {
        items: variantIdArray.map((variantId) => ({
          id: variantId,
          quantity: 1
          // properties: {
          // // likely don't want to add "gwp" label; under current implementation that will prevent users from removing item, even if GWP code is removed and item now has a cost;
          //   gwp: true,
          //   // "Size" added in original GWP implementation; unclear why;
          // },
        })),
        // https://shopify.dev/docs/api/ajax/reference/cart#bundled-section-rendering
        sections: "ajaxcart"
      };
      var response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      const resObj = {
        resStatus: response.status,
        resMessage: response.message,
        resDescription: response.description
      };
      if (response.status === 200) {
        const resJson = await response.json();
        return {
          ...resObj,
          resJson
        };
      } else {
        return resObj;
      }
    } catch (err) {
      throw err;
    }
  }
  // from skin quiz implementation; can be deleted;
  async handleAddToCartBatch(variantIdArray = [0]) {
    console.log({ variantIdArray });
    try {
      let resArray = [];
      for (let i = 0; i < variantIdArray.length; i++) {
        let theseResults = await this.addToCartShopify([variantIdArray[i]]);
        resArray.push(theseResults);
      }
      let addSuccessVariantIdArray = [], addFailVariantIdArray = [], latestResSections = void 0;
      for (let i = 0; i < resArray.length; i++) {
        let res = resArray[i];
        let { resStatus, resJson } = res;
        if (resStatus === 200 && resJson?.sections) {
          addSuccessVariantIdArray.push(variantIdArray[i]);
          latestResSections = resJson.sections;
        } else if (resStatus === 422) {
          addFailVariantIdArray.push(variantIdArray[i]);
        } else {
        }
      }
      latestResSections && this.updateCart(latestResSections);
      if (addSuccessVariantIdArray.length > 0) {
      }
      if (addFailVariantIdArray.length > 0) {
      }
    } catch (err) {
      throw err;
    }
  }
  async getCodeHashesBatch(codeArray) {
    let codeHashes = [];
    for (let code of codeArray) {
      let codeHash = await this.getCodeHash(code);
      codeHashes.push(codeHash);
    }
    return codeHashes;
  }
  // check if hashes match between codes applied to cart and codes from theme data; if so, add item targeted by theme code; could be used in an elementary implementation, but would need substantial additional implementation to either 1) check the Shopify Discount rules are satisfied, or 2) require (and check) redundant info in theme data;
  async workMagic() {
    let activeGwpCodeData = this.getThemeGwpData();
    console.table(activeGwpCodeData);
    let potentialGwpCodes = [];
    let potentialGwpCodeHashes = [];
    let variantIdsToAdd = [];
    if (activeGwpCodeData) {
      let cartDiscountCodes = await this.getCartIdAndDiscountCodes();
      console.log({ cartDiscountCodes });
      cartDiscountCodes.forEach((val) => {
        if (val.applicable === false) {
          potentialGwpCodes.push(val.code);
        }
      });
      potentialGwpCodeHashes = await this.getCodeHashesBatch(potentialGwpCodes);
      potentialGwpCodeHashes.forEach(async (shopifyDiscountCodeHash) => {
        var matchingCodeInTheme = activeGwpCodeData.find(
          (val) => val.codeHash === shopifyDiscountCodeHash
        );
        if (matchingCodeInTheme) {
          console.log("match:", matchingCodeInTheme.name);
          variantIdsToAdd.push(matchingCodeInTheme.variantId);
        }
      });
      console.log({ variantIdsToAdd });
      this.handleAddToCartBatch(variantIdsToAdd);
    }
  }
};
var GWP_default = GWP;
export {
  GWP_default as default
};
